export default {
    data() {
        return {
            options: [
                {
                    "name": "yes",
                    "label": "Yes",
                    "value": "1",
                },
                {
                    "name": "no",
                    "label": "No",
                    "value": "0",
                }
            ],
        }
    },
}